<template>
  <div class="pi">
    <div v-if="loading" class="muted">{{ $t('ARC_MGMT.LOADING') }}</div>
    <div v-else class="card">
      <table>
        <thead><tr>
          <th>{{ $t('ARC_MGMT.INDICATORS.NAME') }}</th><th>{{ $t('ARC_MGMT.PILLAR') }}</th>
          <th>{{ $t('ARC_MGMT.INDICATORS.BASE') }}</th><th>{{ $t('ARC_MGMT.INDICATORS.NOW') }}</th><th>{{ $t('ARC_MGMT.INDICATORS.GOAL') }}</th>
          <th>{{ $t('ARC_PANEL.INDICATORS.TREND') }}</th><th>{{ $t('ARC_MGMT.INDICATORS.SOURCE') }}</th><th>{{ $t('ARC_MGMT.INDICATORS.SITUATION') }}</th>
        </tr></thead>
        <tbody>
          <tr v-for="k in items" :key="k.id">
            <td class="nm">{{ k.nome }}</td>
            <td><span class="pl" :class="k.pilar">{{ k.pilar }}</span></td>
            <td>{{ kv(k, k.base_valor) }}</td>
            <td><b>{{ kv(k, k.atual) }}</b></td>
            <td>{{ kv(k, k.meta_valor) }}</td>
            <td><svg class="spark" viewBox="0 0 120 34" v-html="sparkline(k)" /></td>
            <td class="src">{{ sourceLabel(k) }}</td>
            <td><span class="sit" :class="k.situacao || 'sem_dados'">{{ $t('ARC_MGMT.SITUATION.' + (k.situacao || 'sem_dados')) }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="note">{{ $t('ARC_PANEL.INDICATORS.NOTE') }}</p>
  </div>
</template>

<script>
import ArcAPI from 'dashboard/api/arc';

export default {
  data() { return { items: [], loading: true }; },
  mounted() { this.load(); },
  methods: {
    async load() { this.loading = true; try { const { data } = await ArcAPI.panelKpis(); this.items = data.payload || []; } finally { this.loading = false; } },
    kv(k, v) { if (v === null || v === undefined) return '—'; return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: k.casas_decimais, maximumFractionDigits: k.casas_decimais }) + (k.unidade || ''); },
    sourceLabel(k) {
      if (k.fonte === 'automatico') return 'Automático' + (k.metrica_automatica ? ` · ${k.metrica_automatica}` : '');
      if (k.fonte === 'integracao') return 'Integração' + (k.rotulo_fonte ? ` · ${k.rotulo_fonte}` : '');
      return 'Informado';
    },
    sparkline(k) {
      const vals = (k.valores || []).filter(v => v.valor != null).sort((a, b) => a.mes - b.mes).map(v => v.valor);
      if (vals.length < 2) return '';
      const min = Math.min(...vals, k.meta_valor != null ? k.meta_valor : Infinity);
      const max = Math.max(...vals, k.meta_valor != null ? k.meta_valor : -Infinity);
      const range = max - min || 1;
      const x = i => 4 + (i * 112) / (vals.length - 1);
      const y = v => 30 - ((v - min) / range) * 26;
      const pts = vals.map((v, i) => `${x(i)},${y(v)}`).join(' ');
      let out = `<polyline points="${pts}" fill="none" stroke="var(--w-500)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`;
      if (k.meta_valor != null) { const my = y(k.meta_valor); out += `<line x1="4" y1="${my}" x2="116" y2="${my}" stroke="var(--s-300)" stroke-width="1" stroke-dasharray="3 3"/>`; }
      const lx = x(vals.length - 1); const ly = y(vals[vals.length - 1]);
      out += `<circle cx="${lx}" cy="${ly}" r="3" fill="var(--w-500)"/>`;
      return out;
    },
  },
};
</script>

<style lang="scss" scoped>
.muted { color: var(--s-500); }
.card { background: var(--white); border: 1px solid var(--s-100); border-radius: 12px; padding: var(--space-normal); overflow-x: auto; }
table { width: 100%; border-collapse: collapse; min-width: 720px; }
th { text-align: left; font-size: 10.5px; text-transform: uppercase; letter-spacing: .5px; color: var(--s-400); padding: 8px 10px; border-bottom: 1px solid var(--s-100); }
td { padding: 10px; border-bottom: 1px solid var(--s-75); font-size: var(--font-size-small); color: var(--s-900); vertical-align: middle; }
tr:last-child td { border-bottom: 0; } .nm { font-weight: var(--font-weight-medium); } .src { color: var(--s-400); font-size: var(--font-size-mini); }
.pl { display: inline-grid; place-items: center; width: 18px; height: 18px; border-radius: 5px; font-weight: 800; font-size: 10.5px; &.A { background: #E6F1FC; color: #1E88E5; } &.R { background: #E7F6EE; color: #1F9D63; } &.C { background: #EFECFF; color: #7B61FF; } }
.spark { width: 120px; height: 34px; display: block; }
.sit { font-size: var(--font-size-mini); font-weight: var(--font-weight-medium); padding: 3px 8px; border-radius: 20px;
  &.no_ritmo { background: var(--g-100); color: var(--g-700); } &.atencao { background: var(--y-100); color: var(--y-700); } &.abaixo { background: var(--r-100); color: var(--r-600); } &.sem_dados { background: var(--s-75); color: var(--s-500); } }
.note { font-size: var(--font-size-small); color: var(--s-500); background: var(--s-25); border: 1px dashed var(--s-200); border-radius: 10px; padding: 12px 14px; margin-top: var(--space-normal); }
</style>
